export default {
  averageRating: {
    id: 'bo_seller_customer_reviews_average_rating',
    defaultMessage: 'Average rating:',
  },
}
